// src/components/resources/calculators/video-dropoff/components/BasicInputs.tsx

/**
 * @file Basic Inputs Component
 * @description Basic input fields for video length and total views
 */

import { NumberInput } from '~/components/shared/NumberInput'

/**
 * Props for the BasicInputs component
 */
interface BasicInputsProps {
  /** Video length in seconds */
  videoLength: number
  /** Total number of views */
  totalViews: number
  /** Callback when video length changes */
  onVideoLengthChange: (length: number) => void
  /** Callback when total views changes */
  onTotalViewsChange: (views: number) => void
}

/**
 * Basic inputs component for video parameters
 * @param {BasicInputsProps} props - Component props
 * @returns {JSX.Element} Rendered basic inputs
 */
export const BasicInputs = ({
  videoLength,
  totalViews,
  onVideoLengthChange,
  onTotalViewsChange
}: BasicInputsProps): JSX.Element => {
  return (
    <div className="mt-8 grid gap-6 px-8 sm:grid-cols-2">
      <div>
        <NumberInput
          id="video-length"
          label="Video Length (seconds)"
          value={videoLength}
          onChange={onVideoLengthChange}
          min={1}
          step={1}
          placeholder="Enter video length in seconds"
          description="How long is your video in seconds"
          tooltip="Enter the total duration of your video in seconds. For example, a 1-minute video would be 60 seconds."
        />
      </div>
      <div>
        <NumberInput
          id="total-views"
          label="Total Views"
          value={totalViews}
          onChange={onTotalViewsChange}
          min={1}
          step={1}
          placeholder="Enter total view count"
          description="Total number of video starts"
          tooltip="The total number of people who started watching your video (video starts)."
        />
      </div>
    </div>
  )
}
